import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import React, { useMemo } from 'react';
import { CardBrands } from 'types';
import { cardBrands } from 'appConstants';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import style from './CardBrandSelect.module.scss';

interface ICardBrandSelect {
	fieldId: string;
	useCustomerMcc: boolean;
	selectedAdditionalMccCardBrand: CardBrands | null;
	reservedMccCardBrands: (CardBrands | null)[];
	changeMccCardBrand: (id: string, value: CardBrands) => void;
	setShowAdditionalMccCards: (value: boolean) => void;
}

const CardBrandSelect: React.FC<ICardBrandSelect> = ({
	fieldId,
	selectedAdditionalMccCardBrand,
	reservedMccCardBrands,
	changeMccCardBrand,
	setShowAdditionalMccCards,
	useCustomerMcc,
}) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			({ getFieldValue }) => ({
				validator(_, value) {
					if (getFieldValue(`mcc-${fieldId}`) && !value && !useCustomerMcc) {
						setShowAdditionalMccCards(true);
						return Promise.reject(new Error(t('selectCardBrand')));
					}
					return Promise.resolve();
				},
			}),
		],
		[t, fieldId, useCustomerMcc],
	);

	const handleChange = (value: CardBrands) => {
		changeMccCardBrand(fieldId, value);
	};

	const mappedOptions = useMemo<ISelectOption[]>(
		() =>
			cardBrands.map((el) => {
				const reservedMccCardBrandsWithExcludedSelfValue = reservedMccCardBrands.filter(
					(reserved) => reserved !== selectedAdditionalMccCardBrand,
				);
				return {
					id: el.id,
					name: el.name,
					disabled: reservedMccCardBrandsWithExcludedSelfValue.includes(el.id),
				};
			}),
		[reservedMccCardBrands],
	);

	return (
		<FormSelect
			containerClassName={style.select}
			testId="CardBrandSelect"
			name={`cardBrand-${fieldId}`}
			label="cardBrandLabel"
			disabled={useCustomerMcc}
			options={mappedOptions}
			onChange={handleChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(CardBrandSelect);
